import React from 'react';
import Modal from 'react-modal';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {Input, Textarea} from 'components/vitrade-forms/common';
import {toastr} from 'react-redux-toastr';
import style from './style.scss';
import CONFIG from 'base/constants/config';
import Recaptcha from 'react-recaptcha';
import {connect} from 'react-redux';
import {Requests} from 'api';
import {closeSendRequestForm} from 'actions';

class SendRequest extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      name: '',
      email: '',
      phone: '',
      description: '',
      isSubmit: false,
      status: 1
    };
    this.props.validators['formRequestProduct'] = [];
    this.closeModal = this.closeModal.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  closeModal() {
    this.props.dispatch(closeSendRequestForm());
  }

  validateSubmitForm() {
    let isValid = true;
    this.props.validators['formRequestProduct'].map(validator => {
      if (isValid) {
        isValid = validator.validate();
      } else {
        validator.validate();
      }
    });
    if (!isValid) {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin');
      return false;
    }
    return isValid;
  }

  onSubmit(e) {
    e.preventDefault();
    if (this.validateSubmitForm()) {
      const {name, email, phone, description} = this.state;
      const data = {
        name: name,
        email: email,
        phone: phone,
        description: description,
        productId: this.props.productId
      };
      this.setState({isSubmit: true});
      Requests.actions.send.request({}, {data}).then(response => {
        this.setState({isSubmit: false});
        toastr.success('Thành công!', 'Yêu cầu của bạn đã gửi.');
        this.closeModal();
      }).catch(error => {
        this.setState({isSubmit: false});
      });
    }
  }

  render() {
    const styles = {
      content : {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }
    };
    const {name, email, phone, description, isSubmit} = this.state;
    return (
      <Modal
        isOpen={this.props.isOpenForm}
        onRequestClose={this.closeModal}
        style={styles}
        bodyOpenClassName="request-form-modal-open"
        className="send-request-container">
        <div className="send-request-popup">
          <div className="send-request-popup-content-wrap">
            <button type="button" className="btn-close-send-request" onClick={this.closeModal}>X</button>
            <form className="send-request-popup-content" name="formRequestProduct" method="POST" onSubmit={this.onSubmit} noValidate>
              <h2 className="send-request-form-title">Gửi yêu cầu</h2>
              <Input type="text" placeholder="Tên..."
                className="has-feedback fg-custom"
                iconClassName="fa-user-o"
                name="name"
                value={name}
                required={true}
                onChange={this.onChange}
                bindValidator={this} channel="formRequestProduct"
                errorMessage="Tên không được để trống"
              />
              <Input type="email" placeholder="Email..."
                className="has-feedback fg-custom"
                iconClassName="fa-at"
                name="email"
                value={email}
                onChange={this.onChange}
                required={true}
                bindValidator={this} channel="formRequestProduct"
                errorMessage="Bạn vui lòng cung cấp email"
              />
              <Input type="text" placeholder="Số điện thoại..."
                className="has-feedback fg-custom"
                iconClassName="fa-mobile"
                name="phone"
                value={phone}
                onChange={this.onChange}
                bindValidator={this} channel="formRequestProduct"
                errorMessage="Bạn vui lòng cung cấp số điện thoại"
              />
              <Textarea type="text" placeholder="Nội dung yêu cầu..."
                className="fg-custom vitrade-textarea"
                iconFontSet="glyphicon"
                iconClassName="glyphicon-user"
                name="description"
                value={description}
                onChange={this.onChange}
                bindValidator={this} channel="formRequestProduct"
                errorMessage="Bạn vui lòng nhập mô tả ngắn"
              />
              <div className="google-captcha form-group">
                <Recaptcha sitekey={CONFIG.CAPTCHA_KEY}/>
              </div>
              <LaddaButton className="btn-send-request" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Gửi yêu cầu</LaddaButton>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

SendRequest.defaultProps = {
  validators: {}
};

const mapStateToProps = (state) => {
  return {
    isOpenForm: state.popupProduct.isOpenForm,
    productId: state.popupProduct.productId
  };
};

export default connect(mapStateToProps)(SendRequest);



// WEBPACK FOOTER //
// ./components/partials/product/send-request/SendRequest.jsx